module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jj0Q5"))).then(() => parcelRequire('d0iPb'));